/**
 * useLatestRef — assign-during-render ref capture.
 *
 * Stores the latest value of `value` in a `useRef` and updates it during
 * render. Read at event-fire time, this gives "useEvent" semantics — the
 * latest committed closure is invoked even when stable handler identities
 * (`useCallback([])`) are wired to DOM events.
 *
 * Safe in concurrent mode for this use case because callers ONLY read
 * `ref.current` inside post-commit DOM event handlers (onMouseEnter,
 * onFocus, onPointerDown, intersection callbacks). An aborted concurrent
 * render that wrote `ref.current` is overwritten by the next committed
 * render before any event handler can read it — there is no window during
 * which an aborted closure can fire.
 *
 * Internal helper. Not in the public barrel.
 */
import { useRef } from 'react';
export function useLatestRef(value) {
  const ref = useRef(value);
  ref.current = value;
  return ref;
}